module.exports = __webpack_public_path__ + "img/ring.d805206e.svg";